import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  filterContainer: {
    width: '320px',
    padding: anatomy['space-24'],
    background: colors.brandGhostBackground,
    borderRadius: anatomy.borderRadiusS,
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-16'],
  },
  filterTitle: {
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    fontFamily: fonts.din2014Demi,
  },
  filter: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-20'],
  },
  filterParticipantsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
  },
  filterParticipantsTitle: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    fontFamily: fonts.din2014Demi,
  },
  filterParticipants: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: anatomy['space-8'],
    ':not(#__unused__) > button': {
      padding: '8px 16px',
      fontSize: '14px',
      border: `1px solid ${colors.tertiaryBorder}`,
    },
  },
});
